/** The record keys the toolbar's "all" selects on a Bank table: every Bank record of the year. */
export const selectFillBankKeys = (records: { key?: string; year?: number }[], year: number): string[] =>
    records.filter((r): r is { key: string; year?: number } => Boolean(r.key) && r.year === year).map((r) => r.key);
